<template>
<div>
    <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field label="Search" v-model="search"></v-text-field>
    </v-toolbar>
    <v-data-table :headers="headers" :loading="loading" :search="search" :items="auditLog" :rows-per-page-items="[25, 50, 100, 250]" item-key="id" align-center>
        <template v-slot:items="props">
            <td class="justify-center layout px-0">
                <v-layout justify-center align-center>
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn flat small color="black" v-on="on">
                            <v-icon small>settings</v-icon>
                            <v-icon class="ml-2" small>arrow_drop_down</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-tile v-for="(action, index) in props.item.actions" :key="index" dense @click="processAction(props.item, action.description)">
                            <v-list-tile-action>
                                <v-icon small>{{action.icon}}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ action.description }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-menu>
                <v-btn icon v-if="props.item.serviceAccount&&props.item.serviceAccount.deviceId" @click="routeToDevice(props.item.serviceAccount.deviceId)"><v-icon>launch</v-icon></v-btn>
                </v-layout>
                
            </td>
            <td class="text-xs-center">{{props.item.referenceType}}</td>
            <td class="text-xs-center">{{props.item.reference}}</td>
            <td class="text-xs-center">{{props.item.issue}}</td>
            <td class="text-xs-center">{{props.item.description}}</td>
        </template>
    </v-data-table>


    <!-- Add Service account modal -->
    <v-dialog v-model="serviceAccountModal" persistent width="600px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Create Service Account</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat icon @click="serviceAccountModal=false, item={}">X</v-btn>
            </v-toolbar>
            <v-card-text v-if="item&&item.packages">
                <v-list>
                    <v-autocomplete ref="selectablePackages" v-on:blur="$refs['selectablePackages'].blur()" clearable hide-no-data flat color="primary" style="font-size: 12px" :items="item.packages" v-model="item.serviceAccount.packagesIspId" item-value="id" label="*ISP Package">
                                <template v-slot:selection="data">{{ data.item.name }}</template>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-tile-content>
                                            <v-list-tile-title class="grey--text font-weight-bold">{{data.item.name}} <span v-if="data.item.packagesFno.isGlobal">(Globally Available)</span></v-list-tile-title>
                                            <v-list-tile-sub-title>
                                                <v-layout align-center class="grey--text font-weight-light">
                                                    <v-icon color="light-green">arrow_drop_down</v-icon>
                                                    {{data.item.packagesFno.speedProfile.downloadMbps}}
                                                    <v-icon color="red">arrow_drop_up</v-icon>
                                                    {{data.item.packagesFno.speedProfile.uploadMbps}}
                                                </v-layout>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <v-list-tile dense>
                                    <v-list-tile-action>
                                        <v-icon>event</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size:14px">
                                            Active Date:
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="width: 200px" :key="dateKey">
                                        <span @click="dateModal=true" style="cursor: pointer; font-size: 14px">{{formatDate(item.serviceAccount.fnoActivationDate)}}</span>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-btn flat :disabled="!item.serviceAccount.fnoActivationDate || !item.serviceAccount.packagesIspId" @click="createAccount(item, item.serviceAccount)">Create Account</v-btn>
                </v-list>
                <!-- <v-layout justify-center>
                    <v-flex xs6>
                        
                    </v-flex>
                    <v-flex xs6>
                        <v-list dense>
                            
                        </v-list>
                    </v-flex>

                </v-layout> -->
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog ref="dialog" v-model="dateModal" lazy full-width width="750px">
        <v-date-picker v-if="item.serviceAccount" style="height: 350px" landscape full-width scrollable v-model="item.serviceAccount.fnoActivationDate">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dateModal=false">OK</v-btn>
        </v-date-picker>
    </v-dialog>

</div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
    data() {
        return {
            auditLog: [],
            dateModal: false,
            dateKey: 0,
            loading: false,
            item: {},
            search: '',
            serviceAccountModal: false,
            headers: [{
                    text: "Actions",
                    align: "center",
                    sortable: false
                },
                {
                    text: "Type",
                    align: "center",
                    value: 'referenceType'
                },
                {
                    text: "Reference",
                    align: "center",
                    value: 'reference'
                },
                {
                    text: "Issue",
                    align: "center",
                    value: 'issue'
                },
                {
                    text: "Description",
                    align: "center",
                    value: 'description'
                }
            ]
        }
    },
    async created() {
        this.loading = true
        this.auditLog = await this.getServiceAccountAudit()
        this.loading = false
    },
    watch: {
        'item.serviceAccount.fnoActivationDate': {
            immediate: true,
            handler(value){
                this.dateKey ++
            }
        }
    },
    methods: {
        async createAccount(item, serviceAccount){
            serviceAccount.initialActivation = serviceAccount.fnoActivationDate
            await Api().post('/serviceAccounts', serviceAccount).then(res=>{
                let index = this.auditLog.indexOf(item)
                this.auditLog.splice(index,1)
                this.item = {}
                this.serviceAccountModal = false
            })
        },
        async createServiceAccount(item){
            this.item = item
            this.item.packages = await this.getAvailablePackages({customerOrganisationId: item.serviceAccount.customerOrganisationId, locationId: item.serviceAccount.locationId, downloadMbps: item.serviceAccount.downloadMbps, uploadMbps: item.serviceAccount.uploadMbps})
           if(this.item.packages.length>0){
               this.item.serviceAccount.packagesIspId = this.item.packages[0].id
           }
           this.item.serviceAccount.serviceAccountIdentifier= Math.floor(Math.random() * 1000000000000) + 1
           this.serviceAccountModal = true
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "dd mmm, yyyy");
            } else {
                null;
            }
        },
        async getAvailablePackages(item) {
            let result = []
            await Api().get('/supplier/packagesIsps/basic/active/'+item.customerOrganisationId).then(res=>{
                result = res.data
            })
            // await Api().get('/packagesIsp/'+item.customerOrganisationId+'/'+item.locationId+'/'+item.downloadMbps+'/'+item.uploadMbps).then(res => {
            //     result = res.data
            // })
            return result
        },
        async getServiceAccountAudit() {
            let result = []
            await Api().get('/serviceAccountAudit').then(res => {
                result = res.data
            })
            return result
        },
        async processAction(item, action) {
            switch(action){
                case 'Create service account from bridge':
                    this.createServiceAccount(item)
                    break
            }
        },
        routeToDevice(id){
            this.$router.push({
                path: "/devices/" + id
            });
        }
    }
}
</script>
